// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Col, Layout, Row, Button } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import Account from '../Account'
import grabLogo from 'assets/images/grab-logo.svg'
import './TopBar.less'
import CityFilter from '../CityFilter'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import ImageUploadType from '../image-upload/ImageUploadType'

class TopBar extends React.Component {
  render () {
    const { toggleMenuCollapsed } = this.props
    return (
      <Layout.Header className='top-bar'>
        <Row justify='space-between'>
          <Col span={20}>
            <Button type='text' onClick={toggleMenuCollapsed}>
              <MenuOutlined />
            </Button>
            <img className='logo' src={grabLogo} alt='' />
            <Route
              path={['/upload', '/uploadqueue', '/dongleupload']}
              children={({ match }) => {
                return match ? <CityFilter /> : null
              }}
            />
            {/*<Route*/}
            {/*  path={['/upload']}*/}
            {/*  children={({ match }) => {*/}
            {/*    return match ? <ImageUploadType /> : null*/}
            {/*  }}*/}
            {/*/>*/}
          </Col>
          <Col style={{ textAlign: 'right' }} span={4}>
            <Account />
          </Col>
        </Row>
      </Layout.Header>
    )
  }
}

export default connect(
  ({ app }) => ({ menuCollapsed: app.menuCollapsed }),
  ({ app }) => ({ toggleMenuCollapsed: app.toggleMenuCollapsed })
)(TopBar)
